import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, MenuItem, Select } from '@material-ui/core'
import styled from 'styled-components'

const StyledFormControl = styled(FormControl)`
  margin: 0;
  min-width: 180px;
`

const StyledSelect = styled(Select)`
  color: ${({ theme }) => theme.colors.gray[900]};
  font-size: 1rem;
`

const WipSavedSummarySelect = ({ items, selectedId, onSelect, disabled }) => {
  if (!items || items.length === 0) {
    return null
  }

  const handleChange = event => {
    const id = event.target.value
    if (onSelect) onSelect(id)
  }

  return (
    <StyledFormControl>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ marginBottom: 0, marginRight: 20 }}>Saved summary</h2>
        <StyledSelect
          labelId="wip-saved-summary-label"
          id="wip-saved-summary-select"
          value={selectedId || ''}
          onChange={handleChange}
          disabled={disabled}
          displayEmpty
        >
          {items.map(item => (
            <MenuItem key={item.id} value={item.id}>
              {item.label}
            </MenuItem>
          ))}
        </StyledSelect>
      </div>
    </StyledFormControl>
  )
}

WipSavedSummarySelect.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  selectedId: PropTypes.string,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
}

WipSavedSummarySelect.defaultProps = {
  items: [],
  selectedId: null,
  onSelect: null,
  disabled: false,
}

export default WipSavedSummarySelect
